<main>
  <ul>
    <li>
      <div class="entry" (click)="navigateUrl('police')">
        <span class="entry__image">
          <ui-icon nameIcon="local_police"></ui-icon>
        </span>
        <span class="caption">Законы</span>
      </div>
    </li>
    <li>
      <div class="entry" (click)="navigateUrl('vacantion')">
        <span class="entry__image">
          <ui-icon nameIcon="engineering"></ui-icon>
        </span>
        <span class="caption">Вакансии</span>
      </div>
    </li>
    <li *ngIf="!(authService.isAuthenticated$ | async)">
      <div class="entry" (click)="navigateUrl('login')">
        <span class="entry__image">
          <ui-icon nameIcon="login"></ui-icon>
        </span>
        <span class="caption">Личный кабинет</span>
      </div>
    </li>
    <li *ngIf="(authService.isAuthenticated$ | async)">
      <div class="entry" (click)="navigateUrl('chat')">
        <span class="entry__image">
          <ui-icon nameIcon="chat"></ui-icon>
        </span>
        <span class="caption">Сообщения и звонки</span>
      </div>
    </li>
  </ul>
</main>
